module.exports = __webpack_public_path__ + "static/scale-model-of-statue-of-david-in-sioux-falls-south-dakota-e199e6149787e9f0ab1fb002c67e5033.png";